import { motion } from 'framer-motion';
import { ArrowUpRight, Github } from 'lucide-react';

const ProjectCard = ({ project, index, handleOpenModal }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            className="group relative"
        >
            <div
                className="glass-card p-8 h-full flex flex-col relative overflow-hidden border border-white/5 bg-white/[0.02] hover:bg-white/[0.05]"
                onClick={() => handleOpenModal(project)}
            >
                <div className="flex justify-between items-start mb-6">
                    <div className="p-3 rounded-xl bg-primary-purple/10 text-primary-purple">
                        <Github size={24} />
                    </div>
                    <ArrowUpRight size={24} className="text-gray-500 group-hover:text-white group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" />
                </div>

                <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-primary-purple transition-colors">
                    {project.title}
                </h3>

                <p className="text-gray-400 text-sm leading-relaxed mb-8 line-clamp-3 flex-1">
                    {project.description}
                </p>

                <div className="flex flex-wrap gap-2 mt-auto">
                    {project.techStack.slice(0, 3).map((tech, i) => (
                        <span
                            key={i}
                            className="text-xs px-3 py-1 rounded-full border border-white/10 text-gray-400 group-hover:border-primary-purple/30 group-hover:text-primary-purple transition-colors"
                        >
                            {tech}
                        </span>
                    ))}
                </div>
            </div>
        </motion.div>
    );
};

export default ProjectCard;
